<li [id]="id" [class.disabled]="disabled" routerLinkActive="activeRoute">
  <a
    #dropdownToggle
    class="d-flex align-items-center"
    [attr.data-toggle]="disabled ? null : 'collapse'"
    [attr.data-bs-toggle]="disabled ? null : 'collapse'"
    [attr.data-bs-target]="disabled ? null : '#' + dropId"
    [attr.aria-expanded]="disabled ? false : show"
    [attr.aria-controls]="dropId"
    (keydown)="onKeydown($event)"
    (click)="clicked()"
    [attr.aria-disabled]="disabled"
    [title]="title"
    tabindex="0"
  >
    <i class="bi" [class]="icon"></i>
    <span class="title ps-3">{{ title }}</span>
    <i class="bi bi-chevron-down"></i>
  </a>
  <ul
    #dropDown
    [class.show]="show"
    [attr.id]="dropId"
    class="collapse list-unstyled"
    [attr.aria-labelledby]="id"
    data-parent="#menu"
    data-bs-parent="#menu"
  >
    <ng-content></ng-content>
  </ul>
</li>
